import { isObject, snakeCase } from "lodash";

// Lodash's snakeCase fn does not
const snake = (str: any) => snakeCase(str).replace(/_(\d)/g, "$1");

/**
 * Changes camelcase objects into snake case with correction for how we name things with numbers
 *
 * @param {any} obj [description]
 */
export function prepareForAPI(obj: any): any {
  if (
    typeof obj === "string" ||
    typeof obj === "number" ||
    typeof obj === "boolean" ||
    obj === null
  ) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(prepareForAPI);
  }

  const output = {};
  const keys = Object.keys(obj);

  /* tslint:disable */
  for (let i = 0; i < keys.length; i++) {
    /* tslint:enable */
    const key = keys[i];
    const k = snake(key);

    if (Array.isArray(obj[key])) {
      output[k] = obj[key].map(prepareForAPI);
    } else if (isObject(obj[key])) {
      output[k] = prepareForAPI(obj[key]);
    } else {
      output[k] = obj[key];
    }
  }
  return output;
}
